module.exports = __webpack_public_path__ + "static/media/enterprise_project.01c9ea26.svg";